import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import 'primeicons/primeicons.css';
import { Button } from 'primereact/button';
import ModalCompany, { DeleteCompany } from '@/components/ModalCompany';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCompany } from '@/redux/slices/company/companySlices';
import './styles.scss';
import { Toast } from 'primereact/toast';
import { Paginator } from 'primereact/paginator';

const Company = () => {
  const dispatch = useDispatch();
  const [visibleAddCompany, setVisibleAddCompany] = useState(false);
  const [companyData, setCompanyData] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window?.innerWidth);
  const { items = [], counts, status, error } = useSelector((state) => state.company);
  const [paginationParams, setPaginationParams] = useState({ limit: 10, offset: 0 });
  const toast = useRef(null);

  const BodyTemplate = (rowData) => {
    const [visible, setVisible] = useState(false);
    return (
      <div className='card flex justify-content-start'>
        <Button
          icon='pi pi-pencil'
          type='button'
          rounded
          style={{ marginRight: '5px' }}
          onClick={() => editRow(rowData)}
        />
        <DeleteCompany
          visible={visible}
          open={() => {
            setVisible(true);
          }}
          hide={() => {
            setVisible(false);
          }}
          companyData={rowData}
          updateLoad={updateLoad(paginationParams)}
        />
      </div>
    );
  };

  const updateLoad = (params) => () => {
    setPaginationParams(params);
    dispatch(fetchCompany(params));
  };

  const editRow = (rowData) => {
    setCompanyData(rowData);
    setVisibleAddCompany(true);
  };

  const dateBodyTemplate = (rowData) => {
    const date = new Date(rowData.created_at);
    return date.toLocaleDateString('uk', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };
  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  const cols = [
    { field: 'name', header: 'Назва підриємства', style: { maxWidth: '320px' }, sortable: true },
    {
      field: 'created_at',
      header: 'Дата створення',
      filterField: 'date',
      body: dateBodyTemplate,
      style: { maxWidth: '120px' },
      sortable: true,
    },
  ];

  const openModalHeader = () => {
    setCompanyData(null);
    setVisibleAddCompany(true);
  };

  const onPageChange = (e) => {
    const newOffset = e.first;
    updateLoad({ limit: e.rows, offset: newOffset })();
  };

  const header = (
    <div className='flex align-items-center justify-content-end gap-3'>
      <Button icon='pi pi-plus' onClick={openModalHeader} />
    </div>
  );

  const footer = (
    <Paginator
      first={paginationParams.offset}
      rows={paginationParams.limit}
      totalRecords={counts}
      onPageChange={onPageChange}
    />
  );

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    dispatch(fetchCompany(paginationParams));
  }, [dispatch, paginationParams]);

  useEffect(() => {
    if (status === 'failed') {
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }
  }, [error, status]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className='page'>
      <h2 className='page__title'>Управління ТЗД</h2>
      <DataTable
        value={items}
        header={header}
        responsiveLayout='scroll'
        scrollable
        showGridlines
        scrollHeight='1000px'
        footer={footer}
        rows={paginationParams.limit}
        emptyMessage='Поки що немає даних'
      >
        {cols.map(({ field, header, ...props }, index) => (
          <Column key={index} field={field} header={header} {...props} />
        ))}
        <Column header='Редагування' frozen={windowWidth > 600} body={BodyTemplate} alignFrozen='right'></Column>
      </DataTable>

      <ModalCompany
        visible={visibleAddCompany}
        hide={() => setVisibleAddCompany(false)}
        updateLoad={updateLoad(paginationParams)}
        companyData={companyData}
      />
      <Toast ref={toast} />
    </div>
  );
};

export default Company;
